import React, { createContext, useContext, useState, useEffect } from 'react';
import { api, authApi } from './api';
import { hasRoleLevel } from './roles';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('nexhr_token');
    if (token) {
      api.setToken(token);
      authApi.me()
        .then(data => setUser(data.user))
        .catch(() => { api.setToken(''); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const response = await authApi.login(email, password);
      const payload = response?.data ?? response;
      const token = payload?.token ?? '';
      const loggedInUser = payload?.user ?? null;

      if (!token || !loggedInUser) {
        return { success: false, error: 'Invalid login response from server' };
      }

      api.setToken(token);
      setUser(loggedInUser);
      return { success: true, user: loggedInUser };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const logout = async () => {
    try { await authApi.logout(); } catch {}
    api.setToken('');
    setUser(null);
  };

  const hasAccess = (requiredRole) => {
    if (!user) return false;
    return hasRoleLevel(user.role, requiredRole);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, hasAccess, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
